import type { WorkflowInstanceKey } from '@workflows/types';

/**
 * Строковый ключ экземпляра формы для ключей хранилища и партиций очередей.
 */
export function workflowInstanceKeyToString(
  requestNumber: string,
  instance: WorkflowInstanceKey,
): string {
  return [
    requestNumber,
    instance.requestWorkflowId,
    instance.nodeId,
    instance.formId,
  ].join(':');
}
